<template>
    <el-dialog
        title="供应商评分表"
        class="key-data-delivery-legal-dialog"
        :append-to-body="true"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="!confirmLoading && !pdfTransforming"
        ref="dialogRef"
        width="98%"
        top="3vh"
        :before-close="close"
    >
        <div v-loading="loading" class="content-wrap" ref="contentRef">
            <div class="title-container">
                <span class="title">供应商基础信息</span>
            </div>
            <PersonBaseInfo ref="biRef" :pdfTransforming="pdfTransforming" />
            <div class="title-container">
                <span class="title">资质信息</span>
            </div>
            <el-table :data="qlfTableData" :span-method="arraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="businessType" label="业务类型" width="120"></el-table-column>
                <el-table-column prop="propertyNature" label="主体性质" width="120"></el-table-column>
                <el-table-column prop="zzlx" label="资质类型">
                    <template slot-scope="scope">
                        <div v-html="scope.row.zzlx"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="qualificationFlag" label="是否符合" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>是否符合</span>
                    </template>
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.qualificationFlag" label="符合">符合</el-radio>
                        <el-radio v-model="scope.row.qualificationFlag" label="不符合">不符合</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sm" label="说明"></el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="title-container">
                <span class="title">能力评估</span>
                <div class="sub-title">1、运营能力</div>
            </div>
            <el-table :data="operationTableData" :span-method="opArraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="pgwd" label="评估维度" width="130"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明" min-width="300">
                    <template slot-scope="scope">
                        <div v-if="scope.$index === 0">
                            <div>1、是否有行业服务经验（例：泛家电、泛快消、日化、经销、生产物流、家具、电商等）；</div>
                            <div>2、是否有城配场景服务经验（例：商超、2B门店、2C入户、工地、上撤样、短驳、RDC仓等）；</div>
                            <div>3、相应从业年限。</div>
                            <el-table :data="scope.row.experienceDetailList" header-row-class-name="header-bg">
                                <el-table-column prop="index" label="序号" width="60">
                                    <template slot-scope="cuScope">
                                        <span>{{ cuScope.$index + 1 }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="serviceIndustry" label="服务行业">
                                    <template slot="header" slot-scope="cuScope">
                                        <span class="required">*</span><span>服务行业</span>
                                    </template>
                                    <template slot-scope="cuScope">
                                        <span v-if="pdfTransforming">{{ cuScope.row.serviceIndustry }}</span>
                                        <el-input v-else :class="cuInputError(cuScope.row.serviceIndustry, 'serviceIndustry', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model="cuScope.row.serviceIndustry"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="serviceScenario" label="服务场景">
                                    <template slot="header" slot-scope="cuScope">
                                        <span class="required">*</span><span>服务场景</span>
                                    </template>
                                    <template slot-scope="cuScope">
                                        <span v-if="pdfTransforming">{{ cuScope.row.serviceScenario }}</span>
                                        <el-input v-else :class="cuInputError(cuScope.row.serviceScenario, 'serviceScenario', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model="cuScope.row.serviceScenario"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="year" label="从业年限">
                                    <template slot="header" slot-scope="cuScope">
                                        <span class="required">*</span><span>从业年限</span>
                                    </template>
                                    <template slot-scope="cuScope">
                                        <span v-if="pdfTransforming">{{ cuScope.row.year }}</span>
                                        <el-input v-else :class="cuInputError(cuScope.row.year, 'year', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model="cuScope.row.year"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="remark" label="备注">
                                    <template slot="header" slot-scope="cuScope">
                                        <span class="required">*</span><span>备注</span>
                                    </template>
                                    <template slot-scope="cuScope">
                                        <span v-if="pdfTransforming">{{ cuScope.row.remark }}</span>
                                        <el-input v-else :class="cuInputError(cuScope.row.remark, 'remark', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model="cuScope.row.remark"></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-else-if="scope.$index === 1">
                            司机驾驶车辆年限：
                            <span v-if="pdfTransforming">{{ scope.row.drivingExperience }}</span>
                            <el-input v-else :class="isError(scope.row.drivingExperience) ? 'is-error' : ''" class="drive-age-input" v-model="scope.row.drivingExperience" placeholder="整数数字"></el-input>
                            年
                        </div>
                        <div v-else v-html="scope.row.wdsm"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div v-html="scope.row.pfbz"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="qualificationFlag" label="是否符合">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>是否符合</span>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.noSffh">/</span>
                        <div v-else>
                            <el-radio v-model="scope.row.qualificationFlag" :label="scope.row.fhOptions[0].value">{{ scope.row.fhOptions[0].label }}</el-radio>
                            <el-radio v-model="scope.row.qualificationFlag" :label="scope.row.fhOptions[1].value">{{ scope.row.fhOptions[1].label }}</el-radio>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="require-title">评审要求</div>
            <div class="require-rule margin-bottom-20">1、评审规则：资质信息任一项不符合不得引入；运营能力、服务品质各项总得分低于该项总分80%不得引入。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="confirmLoading || pdfTransforming" @click="close">取 消</el-button>
            <el-button type="primary" :loading="confirmLoading || pdfTransforming" @click="confirm">确认提交</el-button>
            <!-- <el-button @click="generateAndUploadPDF('供应商评分表-配送【个体】.pdf')">生成PDF并上传</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
import PersonBaseInfo from './PersonBaseInfo.vue'
import scoreMixin from './scoreMixin.js';
import { onlineDetail, onlineSave } from '../../../../../../api/qualification.js';

// SRM_BASIC_QUALITY 供应商评分表-配送【个体】
const TYPE = '38'

const INIT_QT = [
    { businessType: '配送', propertyNature: '个体', zzlx: '驾驶员年龄要求：20-60周岁', qualificationFlag: '', sm: '原则上此项中任何一条不符合不得引入。有特殊需求需走供应商特批引入。', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '司机证件：身份证、驾驶证、从业资格证（4.5吨以上）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '车辆证件：行驶证、道路运输证（4.5吨以上）；具有交强险、商业险、第三者责任险(不低于100万）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '车辆、车主(收款人)、司机彩色相片', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '裙带关系：<br />1、是否与安得当地员工有亲属关系；<br />2、是否为安得离职员工', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '车辆使用年限：<br />以购买车辆时间为起始点，以签订合同为止点，不超过8年', qualificationFlag: '', sm: '', resultFlag: '' },
]

const INIT_OT = [
    { pgwd: '行业经验', wdsm: '', pfbz: '做参考记录，不评分', qualificationFlag: '', fhOptions: [{ label: '有', value: '有' }, { label: '无', value: '无' }], resultFlag: '/', experienceDetailList: [{}, {}, {}] },
    { pgwd: '驾龄', wdsm: '', pfbz: '做参考记录，不评分', noSffh: true, resultFlag: '', drivingExperience: '' },
    { pgwd: '车辆其他情况', wdsm: '新能源及通行证：<br />1、是否新能源车辆（电动、混合动力、清洁能源）<br />2、是否有禁行区域的通行证', pfbz: '做参考记录，不评分', qualificationFlag: '', fhOptions: [{ label: '有', value: '有' }, { label: '无', value: '无' }], resultFlag: '' },
    { pgwd: '', wdsm: '车身广告：<br />是否接受喷漆车身广告情况', pfbz: '做参考记录，不评分', qualificationFlag: '', fhOptions: [{ label: '接受', value: '接受' }, { label: '不接受', value: '不接受' }], resultFlag: '' },
]

export default {
    components: { PersonBaseInfo },
    mixins: [scoreMixin],
    data() {
        return {
            currentRow: null,
            visible: false,
            loading: false,
            confirmLoading: false,
            qlfTableData: JSON.parse(JSON.stringify(INIT_QT)),
            operationTableData: JSON.parse(JSON.stringify(INIT_OT)),
            customerListCols: ['serviceIndustry', 'serviceScenario', 'year', 'remark'],
        };
    },
    methods: {
        open(row) {
            this.currentRow = row
            this.setUploadQlfForm(row)
            this.visible = true
            this.loading = true
            onlineDetail({ supplierCode: row.qualificationTypeCode, id: row.id }).then(res => {
                if (res && +res.code === 0) {
                    this.setData(res.data, JSON.parse(res.data.onlineContent || null))
                }
            }).finally(() => { this.loading = false })
        },
        close() {
            this.visible = false
            this.$refs.biRef.reset()
            this.qlfTableData = JSON.parse(JSON.stringify(INIT_QT))
            this.operationTableData = JSON.parse(JSON.stringify(INIT_OT))
        },
        setData(baseInfo, data) {
            this.$refs.biRef.setBaseInfo(baseInfo)
            if (!data) {
                return false
            }
            this.$refs.biRef.setFormData(data.supplierInfo)
            this.qlfTableData[0].resultFlag = data.supplierQualification.resultFlag
            this.qlfTableData.forEach((item, index) => {
                item.qualificationFlag = data.supplierQualification['qualification' + (index + 1) + 'Flag']
            })
            this.operationTableData[0].qualificationFlag = data.operationalCapability.experience.experienceFlag
            this.operationTableData[0].experienceDetailList = data.operationalCapability.experience.experienceDetailList
            this.operationTableData[1].drivingExperience = data.operationalCapability.drivingExperience
            this.operationTableData[2].qualificationFlag = data.operationalCapability.newEnergyFlag
            this.operationTableData[3].qualificationFlag = data.operationalCapability.adFlag
        },
        confirm() {
            const supplierInfo = this.$refs.biRef.getData()
            // 资质信息-是否符合-必填校验
            const qlfValid = this.qlfTableData.every(item => !!item.qualificationFlag)
            const clValid = this.customerListValidate()
            console.log(supplierInfo, qlfValid, clValid)
            if (supplierInfo && qlfValid && clValid) {
                this.generateAndUploadPDF(this.currentRow.qualificationName + '.pdf', () => {
                    this.confirmLoading = true
                    onlineSave(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功!')
                            this.$emit('submit', this.getParamsFromUpload())
                            this.close()
                        }
                    }).finally(() => { this.confirmLoading = false })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请输入必填信息，家庭住址字长不能超过100位，其他字长不能超过20位，驾龄请输入整数!',
                    duration: 4000,
                })
            }
        },
        getParams() {
            const params = {
                type: TYPE,
                onlineContent: '',
                ...this.getParamsFromUpload()
            }
            const supplierInfo = this.$refs.biRef.getData()
            const supplierQualification = {
                resultFlag: this.qlfTableData[0].resultFlag,
            }
            this.qlfTableData.forEach((item, index) => {
                supplierQualification['qualification' + (index + 1) + 'Flag'] = item.qualificationFlag
            })
            const operationalCapability = {
                experience: {
                    experienceFlag: this.operationTableData[0].qualificationFlag,
                    experienceDetailList: this.operationTableData[0].experienceDetailList,
                },
                drivingExperience: this.operationTableData[1].drivingExperience,
                newEnergyFlag: this.operationTableData[2].qualificationFlag,
                adFlag: this.operationTableData[3].qualificationFlag,
            }
            console.log({ supplierInfo, supplierQualification, operationalCapability })
            params.onlineContent = JSON.stringify({ supplierInfo, supplierQualification, operationalCapability })
            return params
        },
        // 运营能力-行业经验-维度说明的表格校验
        customerListValidate() {
            let valid = true
            const { experienceDetailList } = this.operationTableData[0]
            // 判断所有行都无数据
            const allIsEmpty = experienceDetailList.every(item => !item.serviceIndustry)
            if (allIsEmpty) {
                valid = false
                return valid
            }
            // 过滤出有数据的行，并校验格式
            experienceDetailList.filter(item => this.customerListCols.some(key => !!item[key])).forEach(item => {
                this.customerListCols.forEach(key => {
                    if (['', null, undefined].includes(item[key]) || item[key].length > 20) {
                        valid = false
                    }
                })
            })
            if (this.isError(this.operationTableData[1].drivingExperience)) {
                valid = false
            }
            if (this.operationTableData.some(item => !item.noSffh && !item.qualificationFlag)) {
                valid = false
            }
            return valid
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if ([0, 1, 4, 5].includes(columnIndex)) {
                if (rowIndex === 0) {
                    return [6, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        opArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 2) {
                    return [2, 1];
                } else if (rowIndex === 3) {
                    return [0, 0];
                }
            } else if (columnIndex === 4) {
                if (rowIndex === 0) {
                    return [4, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        cuInputError(val, prop, row, index) {
            let isError = false
            const allIsEmpty = this.customerListCols.every(key => ['', null, undefined].includes(row[key]))
            if (allIsEmpty) {
                isError = false
            } else {
                isError = ['', null, undefined].includes(val) || val.length > 20
            }
            return isError
        },
        isError(val) {
            return !/^\d+$/.test(val)
        },
    },
    watch: {
        qlfTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => !item.qualificationFlag || item.qualificationFlag === '不符合') ? '不通过' : '通过'
            },
            deep: true,
        },
    }
}
</script>
<style lang="less">
.key-data-delivery-legal-dialog {
    .el-dialog {
        margin-bottom: 0;
    }

    .el-dialog__body {
        overflow-y: scroll;
        padding: 0;
        height: calc(94vh - 113px);
        box-sizing: border-box;
    }

    .content-wrap {
        padding: 16px;
    }

    .title-container {
        // margin-bottom: 5px;
        font-size: 16px;
        color: #000;

        // i {
        //     float: right;
        //     padding-right: 10px;
        //     font-size: 24px;
        //     cursor: pointer;
        // }
    }

    .title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .sub-title {
        padding: 5px 10px;
        font-size: 14px;
        color: #000;
        background-color: #f2f2f2;
    }

    .el-table {
        // border-right: 1px solid #ebeef5;

        .cell {
            white-space: normal;
        }

        .header-bg th {
            background: #f5f7fa;
        }
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .require-title {
        font-size: 16px;
        color: #000;
    }

    .drive-age-input {
        margin-right: 5px;
        width: 80px;
    }

    .el-dialog__footer {
        padding-top: 15px;
        padding-bottom: 15px;
        text-align: center;
        border-top: 1px solid #d7d7d7;

        .el-button + .el-button {
            margin-left: 30px;
        }
    }

    .required {
        color: #f96c5f;
    }

    .is-error input {
        border-color: #f96c5f;
    }
}
</style>